// @flow

import React from 'react';
import { observer } from 'mobx-react';
import { TwitterButton } from 'react-social';
import FontAwesome from 'react-fontawesome';
import { css } from 'glamor';

const button = css({
    background: '#55acee',
    border: 0,
    color: 'white',
    padding: '3px 5px',
    textDecoration: 'none',
    font: '12px Verdana, sans-serif',
    borderRadius: '2px',

    transition: 'all 0.3s ease',

    '&:hover': {
        background: '#6cb7f0',
    },
});

const icon = css({
    marginRight: '5px',
});

@observer
export default class TwitterShareButton extends React.Component {
    props: {
        url: string,
        message: string,
    };

    render() {
        const { url, message, ...props } = this.props;

        return (
            <TwitterButton
                url={ url || 'https://www.supagemu.com' }
                message={ message || 'A great retro gaming website!' }
                { ...props }
                { ...button }
            >
                <FontAwesome name="twitter" { ...icon } />
                {'SHARE'}
            </TwitterButton>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/global/TwitterShareButton/index.js